import { types as t } from 'mobx-state-tree';
import { useCreateStore, useProvider, useStore } from 'mobx-store-provider';
import * as React from 'react';

export const UncontrolledAudioPlayerStore = t
  .model('UncontrolledAudioPlayerStore', {
    isReady: t.optional(t.boolean, false),
    isPlaying: t.optional(t.boolean, false),
    isStop: t.optional(t.boolean, true),
    durationInSeconds: t.optional(t.number, 0),
    progressInSeconds: t.optional(t.number, 0),
    sliderProgressInSeconds: t.optional(t.number, 0),
    seekWhenPlaying: t.optional(t.boolean, false),
  })
  .actions((self) => ({
    playPause() {
      self.sliderProgressInSeconds = self.progressInSeconds;
      self.isPlaying = !self.isPlaying;
      self.isStop = false;
    },
    stop() {
      self.isPlaying = false;
      self.isStop = true;
    },
    setSlideProgressInSeconds(progressInSeconds) {
      self.sliderProgressInSeconds = progressInSeconds;
    },
    setProgressInSeconds(progressInSeconds) {
      self.progressInSeconds = progressInSeconds;
    },
    setDurationInSeconds(durationInSeconds) {
      self.durationInSeconds = durationInSeconds;
    },
    setSeekInPlaying(value) {
      self.seekWhenPlaying = value;
    },
    setIsReady(isReady) {
      self.isReady = isReady;
    },
    setPlaying(isPlaying) {
      self.isPlaying = isPlaying;
    },
    goBack(seconds: number) {
      self.progressInSeconds = Math.max(self.progressInSeconds - seconds, 0);
      return self.progressInSeconds;
    },
    goNext(seconds: number) {
      self.progressInSeconds = Math.min(self.progressInSeconds + seconds, self.durationInSeconds);
      return self.progressInSeconds;
    },
  }));

export const useUncontrolledAudioPlayerStore = () => {
  return useStore(UncontrolledAudioPlayerStore);
};

export const withUncontrolledAudioPlayerStore = (Component: any) => (props: any) => {
  const uncontrolledAudioPlayerCreateStore = useCreateStore(UncontrolledAudioPlayerStore, {});
  const UncontrolledAudioPlayerStoreProvider = useProvider(UncontrolledAudioPlayerStore);

  return (
    <UncontrolledAudioPlayerStoreProvider value={uncontrolledAudioPlayerCreateStore}>
      <Component {...props} />
    </UncontrolledAudioPlayerStoreProvider>
  );
};

